import { toast } from "react-toastify";
import { useErrorModal } from "../contexts/ErrorModalContext";
import React from "react";

export const ShowApiErrorToast = (error) => {
  // This hook can only be used inside a React component
  try {
    // Try to use the context if available
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { showError } = useErrorModal();
    if (error?.details && Array.isArray(error.details)) {
      showError(error.details.join("\n"));
    } else {
      showError(error?.message || "Something went wrong!");
    }
  } catch {
    // Fallback to toast if not in a React component
    if (error?.details && Array.isArray(error.details)) {
      error.details.forEach((msg) => {
        toast.error(msg || "Something went wrong!", {
          style: {
            fontSize: "0.9rem",
            color: "#721c24",
          },
        });
      });
    } else {
      toast.error(error?.message || "Something went wrong!", {
        style: {
          fontSize: "0.9rem",
          color: "#721c24",
        },
      });
    }
  }
};
